/**
 * 全局使用的键值对
 */
import Vue from 'vue'

export default new Vue({
  data () {
    return {
      tableWidth: {
        'select': '60px',
        'index': '60px',
        'time': '135px',
        'font-3': '60px',
        'font-4': '70px',
        'font-5': '85px',
        'font-6': '95px',
        'font-7': '110px',
        'option2-1': '55px',
        'option2-2': '105px',
        'option4-1': '80px',
        'ip': '115px',
        'phone': '110px',
        'order': '105px',
        'order-tag2-1': '155px'
      },
      orderStatusList: [
        {statusCode: '', statusLabel: '全部'},
        {statusCode: 1, statusLabel: '处理中'},
        {statusCode: 2, statusLabel: '结束'}
      ],
      workOrderStatus: {
        0: '处理中',
        1: '处理中',
        2: '结束',
        3: '处理中'
      },
      order: {
        dataAsset: {
          orderFlow: {
            tenantSubmit: {
              id: 'tenantSubmit',
              name: '申请',
              state: 1,
              flowStep: 1
            },
            managerCheck: {
              id: 'operaterApprove',
              name: '管理员审核',
              state: 2,
              flowStep: 2
            },
            // secondConfirm: {id: 'TenantConfirm', name: '申请单位二次确认', state: 3, flowStep: 3},
            done: {
              id: 'InformationCataLogEnd',
              name: '结束',
              state: 3,
              flowStep: 4
            }
          },
          flowMap: {
            tenantSubmit: 1,
            operaterApprove: 2,
            TenantConfirm: 3,
            InformationCataLogEnd: 4
          }
        },
        PaaS: {
          orderType: {
            10: {name: 'Oracle资源申请', id: 10, code: 'oracle', typeDesc: 'Oracle'},
            11: {name: '虚拟机资源申请', id: 11, code: 'vm', typeDesc: '虚拟机'},
            12: {name: '物理机资源申请', id: 12, code: 'pm', typeDesc: '物理机'},
            13: {name: '负载均衡资源申请', id: 13, code: 'balancing', typeDesc: '负载均衡'},
            14: {name: '网络资源申请', id: 14, code: 'network', typeDesc: '网络'}
          },
          oracle: {
            orderFlow: {
              tenantConfirm: {name: '申请', id: 'tenantConfirm', state: 1},
              letterOffice: {
                name: '经信局审核',
                id: 'letterOffice',
                state: 2
              },
              cloudOffice: {name: '云办审核', id: 'cloudOffice', state: 3},
              securityGroup: {
                name: '安全组审核',
                id: 'securityGroup',
                state: 4
              },
              networkGroup: {
                name: '网络组审核',
                id: 'networkGroup',
                state: 5
              },
              platformGroup: {
                name: '平台组审核',
                id: 'platformGroup',
                state: 6
              },
              securityGroupSecond: {
                name: '漏洞扫描',
                id: 'securityGroupSecond',
                state: 7
              },
              cloudOfficeSecond: {
                name: '交付手册',
                id: 'cloudOfficeSecond',
                state: 8
              },
              done: {name: '结束', id: 'done', state: 9, flowStep: 10}
            }
          },
          network: {
            orderFlow: {
              tenantConfirm: {name: '申请', id: 'tenantConfirm', state: 1},
              letterOffice: {name: '经信局审核', id: 'letterOffice', state: 2},
              cloudOffice: {name: '云办审核', id: 'cloudOffice', state: 3},
              securityGroup: {name: '安全组审核', id: 'securityGroup', state: 4},
              networkGroup: {name: '网络组审核', id: 'networkGroup', state: 5},
              platformGroup: {name: '平台组审核', id: 'platformGroup', state: 6},
              securityGroupSecond: {name: '漏洞扫描', id: 'securityGroupSecond', state: 7},
              cloudOfficeSecond: {name: '交付手册', id: 'cloudOfficeSecond', state: 8},
              done: {name: '结束', id: 'done', state: 9, flowStep: 10}
            }
          },
          vm: {
            orderFlow: {
              tenantConfirm: {name: '申请', id: 'tenantConfirm', state: 1},
              letterOffice: {
                name: '经信局审核',
                id: 'letterOffice',
                state: 2
              },
              cloudOffice: {name: '云办审核', id: 'cloudOffice', state: 3},
              securityGroup: {
                name: '安全组审核',
                id: 'securityGroup',
                state: 4
              },
              networkGroup: {
                name: '网络组审核',
                id: 'networkGroup',
                state: 5
              },
              platformGroup: {
                name: '平台组审核',
                id: 'platformGroup',
                state: 6
              },
              securityGroupSecond: {
                name: '漏洞扫描',
                id: 'securityGroupSecond',
                state: 7
              },
              cloudOfficeSecond: {
                name: '交付手册',
                id: 'cloudOfficeSecond',
                state: 8
              },
              done: {name: '结束', id: 'done', state: 9, flowStep: 10}
            }
          },
          pm: {
            orderFlow: {
              tenantConfirm: {name: '申请', id: 'tenantConfirm', state: 1},
              letterOffice: {name: '经信局审核', id: 'letterOffice', state: 2},
              cloudOffice: {name: '云办审核', id: 'cloudOffice', state: 3},
              securityGroup: {name: '安全组审核', id: 'securityGroup', state: 4},
              networkGroup: {name: '网络组审核', id: 'networkGroup', state: 5},
              platformGroup: {name: '平台组审核', id: 'platformGroup', state: 6},
              securityGroupSecond: {name: '漏洞扫描', id: 'securityGroupSecond', state: 7},
              cloudOfficeSecond: {name: '交付手册', id: 'cloudOfficeSecond', state: 8},
              done: {name: '结束', id: 'done', state: 9, flowStep: 10}
            }
          },
          balancing: {
            orderFlow: {
              tenantConfirm: {name: '申请', id: 'tenantConfirm', state: 1},
              letterOffice: {name: '经信局审核', id: 'letterOffice', state: 2},
              cloudOffice: {name: '云办审核', id: 'cloudOffice', state: 3},
              securityGroup: {name: '安全组审核', id: 'securityGroup', state: 4},
              networkGroup: {name: '网络组审核', id: 'networkGroup', state: 5},
              platformGroup: {name: '平台组审核', id: 'platformGroup', state: 6},
              securityGroupSecond: {name: '漏洞扫描', id: 'securityGroupSecond', state: 7},
              cloudOfficeSecond: {name: '交付手册', id: 'cloudOfficeSecond', state: 8},
              done: {name: '结束', id: 'done', state: 9, flowStep: 10}
            }
          }
        },
        IaaS: {
          dictionaryMap: {
            balancingType: [{remark: '实现公共服务区'}],
            routerType: [{remark: 'ha映射'}]
          }
        },
        orderType: {
          6: {name: '数据目录编目', code: '', typeDesc: '数据目录'},
          10: {name: 'Oracle资源申请', code: 'oracle', typeDesc: 'Oracle'},
          11: {name: '虚拟机资源申请', code: 'vm', typeDesc: '虚拟机'},
          12: {name: '物理机资源申请', code: 'pm', typeDesc: '物理机'},
          13: {name: '负载均衡资源申请', code: 'balancing', typeDesc: '负载均衡'},
          14: {name: '网络资源申请', code: 'network', typeDesc: '网络'}
        }
      },
      historyHeader: [
        {
          title: '节点名称',
          key: 'taskName'
        },
        {
          title: '操作结果',
          key: 'opinion',
          slot: 'opinion'
        },
        {
          title: '备注',
          key: 'remark',
          slot: 'remark',
          width: 300
        },
        {
          title: '操作人',
          key: 'userName',
          slot: 'userName'
        },
        {
          title: '操作时间',
          key: 'endDate'
        }
      ],
      // 历史记录状态字典
      historyOperationMap: {
        unConfirmed: {className: 'warning-color', text: '未确认'},
        return: {className: 'error-color', text: '退回'},
        agree: {className: '', text: '同意'},
        disAgree: {className: 'error-color', text: '拒绝'},
        coordination: {className: '', text: '无'},
        confirmed: {className: '', text: '同意'},
        refused: {className: 'error-color', text: '拒绝'},
        tenantSubmit: {className: '', text: '申请'},
        undefined: {className: '', text: '同意'},
        true: {className: '', text: '协调成功'},
        false: {className: 'error-color', text: '协调失败'},
        tenantRecall: {className: '', text: '申请单位撤回'},
        withdraw: {className: '', text: '申请单位撤回'},
        dataSourceDepWithdraw: {className: '', text: '数源单位撤回'},
        confirm: {className: '', text: '同意'},
        interfaceReturn: {className: 'error-color', text: '接口平台退回'},
        exchangeReturn: {className: 'error-color', text: '交换平台退回'},
        dataReturn: {className: 'error-color', text: '数据架构平台退回'},
        assignReturn: {className: 'error-color', text: '管理员退回'},
        unIndexed: {className: '', text: '同意'},
        stop: {className: 'error-color', text: '关闭'},
        logicInfoResOrderStop: {className: 'error-color', text: '关闭'}
      },
      operationRoleMap: {
        tenant: {urlRole: 'cmp_tenant,cmp_tenant_admin', code: 'cmp_tenant,cmp_tenant_admin'},
        operation: {
          urlRole: 'cmp_operate,cmp_operate_admin',
          code: 'cmp_operate'
        },
        maintain: {
          urlRole: 'cmp_operation_maintenance',
          code: 'cmp_operation_maintenance'
        }
      },
      websocketTypeArr: [
        'RESOURCE_INFO_CREATE', 'DATA_SHARE', 'DATA_SHARE_USER_DEFINED', 'DATA_SHARE_INTERFACE_IMPLEMENT', 'DATA_SHARE_DB_IMPLEMENT', 'DATA_SHARE_INTERFACE_PLAT', 'DATA_SHARE_EXCHANGE_PLAT', 'DATA_SHARE_DATA_FRAMEWORK_PLAT'
      ],
      infoResFormatTypeMap: new Map(),
      allButtonJson: '',
      valid: {phone: /^0?1[3-8][0-9]\d{8}$/}
    }
  }
})



// WEBPACK FOOTER //
// ./src/common/api/globalMap.js